import React, { useCallback, useState } from "react";

import {
  Button,
  Form,
  FormField,
  FormGroup,
  Input
} from "semantic-ui-react";
import swal from "sweetalert";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 as api } from "../../../../services/apis";

import {
  Box,
  Container,
  FormBlock,
  Header
} from "./styles";


const Utm = () => {
  document.title = "Painel Administrativo | Grupo Voitto";
  const [dataInicio, setDataInicio] = useState(new Date());
  const [dataFinal, setDataFinal] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [relatorio, setRelatorio] = useState(false);

  const handleGenerateReport = useCallback(() => {
    setLoading(true);
    setRelatorio(false);

    api
      .post("admin/relatorio/utm-site", {
        data_inicio: dataInicio,
        data_final: dataFinal,
      })
      .then((res) => {
        setRelatorio(res.data.response);
        setLoading(false);

        const acao = JSON.stringify({
          local: "Relatorio",
          texto: `Gerou o relatorio de UTMs entre ${dataInicio} e ${dataFinal}}`,
        });

        api.post("system_logs", { acao });
        swal("Confirmado!", "Relatório de Utms gerado com sucesso", "success");

        window.open(res.data.response, "blank");
      })
      .catch((error) => {
        setLoading(false);
        if (!error.response) {
          return;
        }

        swal(`Algo deu errado`, `Se persistir, contate nosso suporte`, "error");
      });
  }, [dataInicio, dataFinal]);


  return (
    <>
      <AdminMenu />
      <Container>
        <Header>Relatório Mensuração de Utms</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                />
              </FormField>
            </FormBlock>
            <FormGroup>
              <Button
                color="orange"
                onClick={handleGenerateReport}
                loading={loading}
              >
                Gerar Relatório
              </Button>
              {relatorio && (
                <Button
                  style={{ minWidth: "80px" }}
                  onClick={() => window.open(relatorio, "_blank")}
                  color="green"
                >
                  Baixar Relatório
                </Button>
              )}
            </FormGroup>
          </Form>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default Utm;
